var map = {
	"./ardent.png": 56,
	"./ccna.png": 4571,
	"./lq.png": 8643,
	"./nit.png": 7329,
	"./romel.png": 6153,
	"./ucdavis.png": 4057,
	"./ue.png": 2272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;